'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = filter;
exports.filterObjectByKeysOf = filterObjectByKeysOf;
exports.getObjectFromArray = getObjectFromArray;
exports.mapArrToArr = mapArrToArr;
exports.metaMapObjectToOrderedArray = metaMapObjectToOrderedArray;
exports.metaMapToObject = metaMapToObject;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function filter(obj, predicate) {
  var result = {};
  var key;
  for (key in obj) {
    if (obj.hasOwnProperty(key) && predicate(key)) {
      result[key] = obj[key];
    }
  }
  return result;
}

function filterObjectByKeysOf(obj, keysOf) {
  return this.filter(obj, function (key) {
    return typeof keysOf[key] !== 'undefined';
  });
}

//arr = [{foo: 'bar'}, {bat: 'baz'}, {big: 'pun'}, {tu:'pac'}, ...]
//getObjectFromArray(arr, 'big')
//return {big: 'pun'}
function getObjectFromArray(arr, key) {
  return arr.filter(function (props) {
    return typeof props[key] !== 'undefined';
  })[0];
}

function mapArrToArr(arr, callback) {
  return arr.reduce(function (prev, curr) {
    var value = callback(curr);
    if (typeof value !== 'undefined') {
      prev.push(value);
    }
    return prev;
  }, []);
}

function metaMapObjectToOrderedArray(metaMap, obj) {
  var keyPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var ordered = [];
  metaMap.map(function (item) {
    var key = Object.keys(item)[keyPos];
    ordered.push(_defineProperty({}, key, obj[key]));
  });
  return ordered;
}

//arr = [{foo: 'bar', bat: 'baz'}, {big: 'pun', tu: 'pac'}, ...]
//return {foo: 'bar', big: 'pun', ...}
function metaMapToObject(arr) {
  var keyPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  //curr = {foo: 'bar', bat: 'baz'}
  return arr.reduce(function (prev, curr) {
    var key = Object.keys(curr)[keyPos];
    if (key) {
      prev[key] = curr[key];
    }
    return prev;
  }, {});
}

var mOperators = exports.mOperators = {
  filter: filter,
  filterObjectByKeysOf: filterObjectByKeysOf,
  getObjectFromArray: getObjectFromArray,
  mapArrToArr: mapArrToArr,
  metaMapObjectToOrderedArray: metaMapObjectToOrderedArray,
  metaMapToObject: metaMapToObject
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/mOperators.js
// module id = 479
// module chunks = 0